import * as React from 'react';
import Div from "@jumbo/shared/Div";
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import { Typography } from "@mui/material";
import MobileHeader from 'app/components/MobileHeader/MobileHeader';
import Card from '@mui/material/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Chip from '@mui/material/Chip';
import { useLocation, useNavigate } from "react-router-dom";
import moment from 'moment';
import { REFERRER } from 'app/utils/constants/endPoint';
import { getFile } from 'app/services/imageService';
import ImageModal from 'app/components/Modal/ImageModal';
import Swal from 'sweetalert2';
import { isMobile } from 'react-device-detect';

const WebViewRefferalDetail = () => {

	const [file, setFile] = React.useState({
		id: '',
		npwp: '',
	})
	const [open, setOpen] = React.useState(false)
	const [modalParam, setModalParam] = React.useState({
		b64: '',
		fileName: '',
	})

	const navigate = useNavigate();
	let location = useLocation();
	let row = location.state.referrer;

	React.useEffect(() => {
		// if (!isMobile) {
		// 	Swal.fire({
		// 		icon: 'warning',
		// 		title: 'Forbidden!',
		// 		text: 'Halaman ini tidak dapat diakses melalui browser',
		// 		allowOutsideClick: false,
		// 		showConfirmButton: false
		// 	});
		// } else {
			(async () => {
				let tmpFile = { id: '', npwp: '' }

				if (row.npwpImage) {
					const npwpB64 = await getFile(REFERRER.FILE,
						{
							fullPath: row.npwpImage
						}
					)
					tmpFile.npwp = npwpB64

				}
				if (row.ktpImage) {
					const ktpB64 = await getFile(REFERRER.FILE,
						{
							fullPath: row.ktpImage
						}
					)
					tmpFile.id = ktpB64
				}
				setFile(tmpFile)
			})()
		// }
	}, []);

	const navigateBack = () => {
		// 👇️ navigate to /demoLoginWebView
		navigate(-1);
	};

	const convertDate = (d, f = 'DD MMM YYYY') => {
		var date = moment(d);
		return date.format(f);
	}

	const showModal = (data) => {
		setModalParam(data)
		setOpen(true)
	}

	return (
		<Div className='page-wrapper-mobile'>

			{/* 🔥 HEADER */}
			<MobileHeader
				backIcon
				headerTx={"Referral Detail"}
				backOnClick={navigateBack}
			/>

			{/* 🔥 CONTENT */}
			<ContentWrapper isMobile>
				{/* 🔥 input with icon left/right */}
				<Div sx={{ mt: 2 }}>
					{/* 🔥 card (include chips, row - col)*/}
					<Div sx={{ mb: 2 }}>
						<Card variant="outlined" sx={{
							padding: "12px"
						}}>
							<Row className='p-2'>
								<Col>
									<Typography fontSize={12}>Nama Referrer</Typography>
								</Col>
								<Col>
									<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{row.name}</Typography>
								</Col>
							</Row>
							<Row className='p-2'>
								<Col>
									<Typography fontSize={12}>No. Hp</Typography>
								</Col>
								<Col>
									<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{row.phoneNumber}</Typography>
								</Col>
							</Row>
							<Row className='p-2'>
								<Col>
									<Typography fontSize={12}>Email</Typography>
								</Col>
								<Col>
									<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{row.email}</Typography>
								</Col>
							</Row>
							<Row className='p-2 bt-4'>
								<Col>
									<Typography fontSize={12}>Kode Referral</Typography>
								</Col>
								<Col>
									<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{row.referrerCode}</Typography>
								</Col>
							</Row>
							<Row className='p-2 bt-4'>
								<Col>
									<Typography fontSize={12}>Status</Typography>
								</Col>
								<Col className='flex-justify-end'>
									<Chip
										label={row.referralStatus === "WAITING_VERIFICATION" ? "WAITING VERIFICATION" : row.referralStatus}
										size="small"
										color={row.referralStatus === "TERMINATED" ? "error" : "success"}
										sx={{ borderRadius: '5px' }}
									/>
								</Col>
							</Row>
							{row.referralStatus === "TERMINATED" && (
								<Row className='p-2'>
									<Col>
										<Typography fontSize={12}>Tanggal Terminate</Typography>
									</Col>
									<Col>
										<Typography fontSize={12} fontWeight={600} textAlign={"right"}>
										{row.expiredDate ? convertDate(row.expiredDate) : '-'}
										</Typography>
									</Col>
								</Row>
							)}
							<Row className='p-2 bt-4'>
								<Col>
									<Typography fontSize={12}>Nomor Identitas</Typography>
								</Col>
								<Col>
									<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{row.ktpNumber}</Typography>
								</Col>
							</Row>
							<Row className='p-2'>
								<Col>
									<Typography fontSize={12}>Tanggal Lahir</Typography>
								</Col>
								<Col>
									<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{convertDate(row.birthDate)}</Typography>
								</Col>
							</Row>
							<Row className='p-2'>
								<Col>
									<Typography fontSize={12}>Nama Bank</Typography>
								</Col>
								<Col>
									<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{row.bankName}</Typography>
								</Col>
							</Row>
							<Row className='p-2'>
								<Col>
									<Typography fontSize={12}>Nomor Rekening</Typography>
								</Col>
								<Col>
									<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{row.accountNumber}</Typography>
								</Col>
							</Row>
							<Row className='p-2'>
								<Col>
									<Typography fontSize={12}>No NPWP</Typography>
								</Col>
								<Col>
									<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{row.npwpNumber ? row.npwpNumber : '-'}</Typography>
								</Col>
							</Row>
							<Div className='dis-flex-center' >
								{
									file.id &&
									<img
										alt="KTP"
										src={file.id}
										width={120}
										height={120}
										style={{ cursor: "pointer", objectFit: "contain" }}
										onClick={() => showModal({
											fileName: row.ktpImage,
											b64: file.id
										})} />
								}
								{
									file.npwp &&
									<img
										alt="NPWP"
										src={file.npwp}
										width={120}
										height={120}
										style={{ cursor: "pointer", objectFit: "contain", marginLeft: 10 }}
										onClick={() => showModal({
											fileName: row.npwpImage,
											b64: file.npwp,
										})}
									/>
								}
							</Div>
						</Card>
					</Div>

				</Div>
				<ImageModal open={open} setOpen={setOpen} data={modalParam} />
			</ContentWrapper>

		</Div>

	);
};

export default WebViewRefferalDetail;